export default __webpack_public_path__ + "static/androidQrcode-427176f0dbd8538fd54f2a2adca95163.png";